module.exports = __webpack_public_path__ + "images/search.1a53df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/home/search.png
// module id = SrlC
// module chunks = 19